import React from 'react';
import 'broadcastchannel-polyfill';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { authenticationChannelReceiverFactory } from '../../core/middleware/authentication-channel-middleware';
import { buildSubscriptions as buildChannelSubscriptions } from './case-channel-subscriptions';
import { Action, Store } from 'redux';
import { History } from 'history';
// eslint-disable-next-line
import { authenticationChannel } from '@codametrix/ui-common';

// this module exposes a pop-up factory that will handle
// the auth channel subscriptions as well as the store, history

type PopupGeneratorProps = {
  store: Store<unknown, Action<any>>;
  history: History;
  //subscriptions: CMx.ChannelSubscription[]
};

type PopupAppProps = {
  children: React.ReactNode;
};

const popupFactory = (generatorProps: PopupGeneratorProps) => {
  const { store, history } = generatorProps;

  const currentURL = new URL(`${window?.top?.location}`);
  const subscriptions = buildChannelSubscriptions(currentURL);
  authenticationChannelReceiverFactory(subscriptions, store);

  return (appProps: PopupAppProps) => {
    const { children } = appProps;
    return (
      <Provider store={store}>
        <Router history={history}>{children}</Router>
      </Provider>
    );
  };
};

export { popupFactory };
